<script>
    import axios from 'axios'

    const apiToken = 'eAysp47m64oZfbpobIqwNcdTnLWQtfgH'
    const apiBaseUrl = '/api/v2'

    export default {
        data () {
            return {
                api: this.getFeatureApi(),
                groups: [],
                features: [],
                landingDataLoaded: false,
                modalContentLoaded: false,
                modalOpen: false,
                modalContent: {},
                nextFeature: {},
                prevFeature: {},
                modalGroupName: '',
            }
        },
        props: {
            'id': {
                type: Number,
                default: 0
            },
        },
        mounted () {
            this.getFeatureGroup()
        },
        methods: {
            getFeatureGroup() {
                let ffQuery = `{
                              entries(section:["featuresFunctionalityGroups"], id: ${this.id}) {
                                    ...on featuresFunctionalityGroups_featuresFunctionalityGroups_Entry {
                                      groups {
                                        ...on groups_group_BlockType {
                                          groupName
                                          featuresFunctionality {
                                            ...on featuresFunctionality_featuresFunctionality_Entry {
                                            id
                                            slug
                                            featureName
                                            featureBriefDescription
                                            featureSvgIcon {
                                                icon: url
                                            }
                                          }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }`

                this.api.post('', {query: ffQuery})
                    .then((response) => {
                        this.landingDataLoaded = true
                        this.groups = response.data.data.entries[0].groups
                        this.features = this.getFeaturesArrayFromGroups(this.groups)
                        this.openInitialFeature()
                })
            },
            getFeature(slug) {
                let ffQuery = `{
                                  entries(section:["featuresFunctionality"], slug: "${slug}") {
                                        ...on featuresFunctionality_featuresFunctionality_Entry {
      id
      featureName
      featureBriefDescription
      featureSvgIcon {
        icon: url
      }
      featureContent {
        ...on featureContent_oneColumn_BlockType {
          __typename
          typeHandle
          oneColumnHeadline
          oneColumnContent
        }
        ...on featureContent_twoColumn_BlockType {
          __typename
          typeHandle
          column1Headline
          column1Content
          column2Headline
          column2Content
        }
      }
      featureAssets {
        ...on featureAssets_asset_BlockType {
          assetType
          assetHeadline
          assetUrl
          linkText
          asset {
            file: url
          }
        }
      }
    }
  }
}`

                this.api.post('', {query: ffQuery})
                    .then((response) => {
                        this.modalContent = response.data.data.entries[0]
                        this.modalContentLoaded = true
                    })
            },
            getFeatureApi () {
                return axios.create({
                    baseURL: apiBaseUrl,
                    headers: {
                        'Authorization': 'Bearer ' + apiToken,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
            },
            openInitialFeature() {
                let slug = location.hash.replace('#', '')
                if (slug.length) {
                    let key = this.getFeatureKeyBySlug(slug)
                    if (key >= 0) {
                        this.openModal(this.features[key], this.features[key].groupName)
                    }
                }
            },
            getHashSlug(item) {
              return '#' + item.slug
            },
            openModal (item, group) {
                this.modalOpen = true
                this.modalContentLoaded = false
                this.modalGroupName = group
                this.setNextPrevFeature(item.slug)
                this.getFeature(item.slug)
            },
            closeModal() {
                this.modalOpen = false
                location.hash = ''
            },
            setNextPrevFeature (slug) {
                let key = this.getFeatureKeyBySlug(slug)
                this.setNextFeature(key)
                this.setPrevFeature(key)
            },
            getFeatureKeyBySlug (slug) {
                let key = 0
                let keyFound = false
                for (let feature of this.features) {
                    if (feature.slug == slug)  {
                        keyFound = true
                        break
                    }
                    key++
                }
                return (keyFound) ? key : -1
            },
            setNextFeature (key) {
              if (key !== (this.features.length - 1)) {
                  this.nextFeature = this.features[key + 1]
              } else {
                  this.nextFeature = this.features[0]
              }
            },
            setPrevFeature (key) {
                if (key !== 0) {
                    this.prevFeature = this.features[key - 1]
                } else {
                    this.prevFeature = this.features[this.features.length - 1]
                }

            },
            getFeaturesArrayFromGroups (groups) {
                let data = []

                for (let group of groups) {
                    for (let feature of group.featuresFunctionality) {
                        feature.groupName = group.groupName
                        data.push(feature)
                    }
                }
                return data
            },
            getAssetLinkText(linkText) {
                return (linkText !== null) ? linkText : 'Download'
            },
            getAssetUrl(asset) {
                return (asset.assetUrl !== null && asset.assetUrl.length) ? asset.assetUrl : asset.asset[0].file
            }
        }
    }
</script>
